import { Grid2, Snackbar, Tooltip } from "@mui/material";
import ContentCopyOutlinedIcon from "@mui/icons-material/ContentCopyOutlined";
import Styles from "./PaymentStatus.module.scss";
import videofile from "../../../../../../GlobalAssets/videos/paymentProcess.mp4";
import { useState } from "react";

const PaymentStatus = (Props) => {
  const {
    setShowPopup,
    handleGetLinkClick,
    isProcessingCashfree,
    isProcessing,
  } = Props;

  const [tooltipTitle, setTooltipTitle] = useState("Copy");
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  let linkpay = isProcessingCashfree?.paymentLink;
  let link = linkpay?.replace(/"/g, "");

  const handleCopy = () => {
    if (link) {
      navigator.clipboard.writeText(link).then(() => {
        setTooltipTitle("Copied");
        setSnackbarOpen(true);
        setTimeout(() => setTooltipTitle("Copy"), 2000);
      });
    }
  };

  return (
    <>
      {isProcessing ? (
        <Grid2 className={Styles.paymentContainer}>
          <Grid2 className={Styles.desc}>
            Your payment has been initiated and may take some time to process,
            please check the link below to confirm the status.
          </Grid2>
          <Grid2 className={Styles.video}>
            <video autoPlay loop muted width="250" height="200">
              <source src={videofile} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </Grid2>
          <Grid2 className={Styles.linkContainer}>
            <Grid2 className={Styles.link}>{link}</Grid2>
            <Grid2>
              <Tooltip title={tooltipTitle}>
                <ContentCopyOutlinedIcon
                  className={Styles.Copytext}
                  onClick={handleCopy}
                />
              </Tooltip>
            </Grid2>
          </Grid2>
        </Grid2>
      ) : (
        <Grid2 className={Styles.paymentContainer}>
          <Grid2 className={Styles.desc}>
            You have already initiated a payment. You can check the status of
            the previous payment by clicking the link or proceed with another
            plan.
          </Grid2>
          <Grid2 className={Styles.video}>
            <video autoPlay loop muted width="250" height="200">
              <source src={videofile} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </Grid2>
          <Grid2 style={{ display: "flex" }}>
            <Grid2 className={Styles.linkContainer}>
              <Grid2 className={Styles.link}>{link}</Grid2>
              <Grid2>
                <Tooltip title={tooltipTitle}>
                  <ContentCopyOutlinedIcon
                    sx={{ fontSize: 40 }}
                    className={Styles.Copytext}
                    onClick={handleCopy}
                  />
                </Tooltip>
              </Grid2>
            </Grid2>
            <Grid2
              onClick={() => {
                setShowPopup && setShowPopup(false);
                handleGetLinkClick && handleGetLinkClick();
              }}
              className={Styles.linkContainer}
            >
              Proceed ahead
            </Grid2>
          </Grid2>
        </Grid2>
      )}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={2000}
        onClose={() => setSnackbarOpen(false)}
        message="Link copied to clipboard"
      />
    </>
  );
};

export default PaymentStatus;
